<template>
  <v-text-field
    v-model="computedValue"
    v-bind="$attrs"
    v-on="$listeners"
    :counter="computedCounter"
    @paste="onPaste"
    @keydown="checkValue"
    @keydown.enter.prevent="$emit('agree')"
  >
    <template v-for="(value, key) in $scopedSlots" #[key]>
      <slot :name="key" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'DataInputText',
  props: {
    value: {
      required: true,
    },
    descriptors: {
      required: false,
      type: Object,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    computedCounter() {
      if (
        !(this.hasAttribute(this.$attrs.readonly) || this.hasAttribute(this.$attrs.disabled)) &&
        this.descriptors &&
        this.descriptors.max_length
      ) {
        return this.descriptors.max_length;
      }
      return false;
    },
  },
  methods: {
    hasAttribute(attribute) {
      return attribute !== undefined && attribute !== false;
    },
    checkValue(e) {
      const { keyCode, ctrlKey, metaKey } = e;
      if ((ctrlKey || metaKey) && (keyCode === 86 || keyCode === 67 || keyCode === 65)) {
        return;
      }
      const allowedKeyCodes = [8, 9, 37, 39];
      if (allowedKeyCodes.includes(e.keyCode)) {
        return;
      } else if (e.target.selectionStart !== e.target.selectionEnd) {
        return;
      } else if (this.descriptors.max_length) {
        if ((this.computedValue ? this.computedValue.length : 0) >= this.descriptors.max_length) {
          e.preventDefault();
          return;
        }
      }
    },
    onPaste(e) {
      if (
        this.descriptors.max_length &&
        e.clipboardData.getData('text').length +
          (this.value ? this.value.length : 0) -
          (e.target.selectionEnd - e.target.selectionStart) >
          this.descriptors.max_length
      ) {
        e.preventDefault();
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field ::v-deep input {
  font-size: 14px;
  color: map-get($colors, 'font-lighten-1');
}
</style>
